import Chip from '@/components/atoms/chip';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/atoms/Tooltip';
import { cn } from '@/helpers/shadCnUtils';

export const ThemesTooltip = ({ issues, className }: { issues: string[]; className?: string }) => {
  return (
    <Tooltip delayDuration={300}>
      <TooltipTrigger asChild>
        <div
          className={cn([
            'flex w-fit cursor-default items-center gap-1 rounded bg-blue-100/60 px-2 py-0.5 text-xs font-medium text-blue-600',
            className,
          ])}
        >
          <span className="text-xs">Themes</span>
          <span className="text-xs">({issues.length})</span>
        </div>
      </TooltipTrigger>
      <TooltipContent side="top" className="w-fit p-2 shadow-md">
        <div className="space-y-2">
          {issues.map((issue, index) => (
            <div key={index} className="w-fit rounded bg-blue-100/60 px-2 py-1 text-xs font-medium text-blue-600">
              {issue}
            </div>
          ))}
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
